import { render, staticRenderFns } from "./quesSelector.vue?vue&type=template&id=8bdfad3c"
import script from "./quesSelector.vue?vue&type=script&lang=js"
export * from "./quesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports